const Types = {
    mutations: {
        SET_MESSAGE: `SET_MESSAGE`,
        CLEAR_MESSAGE: `CLEAR_MESSAGE`,
        SET_TIMEZONES: `SET_TIMEZONES`,
        SET_COUNTRIES: `SET_COUNTRIES`,
    },
    actions: {
        GET_TIMEZONES: 'GET_TIMEZONES',
    },
    getters: {
        GET_TIMEZONE_NAME_BY_ID: 'GET_TIMEZONE_NAME_BY_ID',
        GET_COUNTRY_NAME_BY_ID: 'GET_COUNTRY_NAME_BY_ID',
        GET_COUNTRY_BY_ID: 'GET_COUNTRY_BY_ID',
        GET_COUNTRY_WITH_CODE: 'GET_COUNTRY_WITH_CODE',
    },
}

export {
    Types
}
